import React from 'react'
import { twMerge } from 'tailwind-merge'

import { HStackProps } from './stack.type'

import { stackStyle } from './stack.css'

const HStack = <E extends React.ElementType = 'div'>({
  as,
  className,
  align,
  justify,
  children,
  ref,
  ...props
}: HStackProps<E>) => {
  const Element = as || 'div'
  return (
    <Element
      className={twMerge(stackStyle({ direction: 'horizontal', align, justify }), className)}
      ref={ref}
      {...props}
    >
      {children}
    </Element>
  )
}
HStack.displayName = 'HStack'

export default HStack
